import { library as library1 } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookF,
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
  faFontAwesome,
  faBehance,
} from "@fortawesome/free-brands-svg-icons";

library1.add(
  faFacebookF,
  faTwitter,
  faLinkedin,
  faInstagram,
  faFontAwesome,
  faBehance,
  faFacebook
);
